import { useAuth0 } from '@auth0/auth0-react';
import Icon, { IconName } from '../../components/Icon';
import './Login.css';

const FEATURES: { icon: IconName; title: string; desc: string }[] = [
  { icon: 'alert', title: 'WHS Compliant', desc: 'Built for workplace health and safety regulations.' },
  { icon: 'clipboard', title: 'One-tap incident reporting', desc: 'Severity and type are auto-assessed for you.' },
  { icon: 'message', title: 'Live SitRep with an AI advisor', desc: 'Ask “what do I do if…” at any moment.' },
  { icon: 'cap', title: 'Built-in crisis training', desc: 'Keep your CIMT ready before it’s needed.' },
  { icon: 'users', title: 'Team Assembly', desc: 'Automatic stakeholder notification and SME coordination.' },
];

export default function Login() {
  const { loginWithRedirect } = useAuth0();
  const handleSignIn = () => void loginWithRedirect();

  return (
    <div className="lg-root">
      {/* ---------- left: brand hero ---------- */}
      <aside className="lg-hero">
        <div className="lg-hero-glow" aria-hidden="true" />

        <header className="lg-brand">
          <img src="/crisis-logo.png" alt="" className="lg-logo" />
          <span className="lg-wordmark">CRISIS SHIELD</span>
        </header>

        <div className="lg-body">
          <span className="lg-badge">
            <span className="lg-badge-dot" />
            AI-assisted incident command
          </span>

          <h1 className="lg-title">
            Critical incidents,<br />calmly under control.
          </h1>

          <p className="lg-lede">
            CIMA guides your team from first report to resolution with AI-assisted
            reporting and management for workplace injuries, data breaches, and
            operational incidents.
          </p>

          <ul className="lg-features">
            {FEATURES.map((f) => (
              <li className="lg-feature" key={f.title}>
                <span className="lg-feature-icon"><Icon name={f.icon} size={19} /></span>
                <span className="lg-feature-text">
                  <span className="lg-feature-title">{f.title}</span>
                  <span className="lg-feature-desc">{f.desc}</span>
                </span>
              </li>
            ))}
          </ul>
        </div>
      </aside>

      {/* ---------- right: sign in ---------- */}
      <main className="lg-panel">
        <div className="lg-signin">
          <div className="lg-signin-brand">
            <img src="/crisis-logo.png" alt="" className="lg-signin-logo" />
            <span className="lg-signin-wordmark">CRISIS SHIELD</span>
          </div>

          <h2 className="lg-signin-title">Welcome back</h2>
          <p className="lg-signin-sub">Sign in to the CIMA incident console for your organisation.</p>

          <button className="lg-btn" onClick={handleSignIn}>
            Sign in securely
            <Icon name="arrowRight" size={18} />
          </button>

          <p className="lg-legal">
            <Icon name="lock" size={14} />
            Protected by single sign-on
          </p>
        </div>
      </main>
    </div>
  );
}
